import {useQuery} from "react-query";
import ShipmentsPerDayApi from "./ShipmentsPerDay.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useShipmentsPerDay(query:IWidgetQuery){
    return useQuery(["fetchShipmentsPerDay", query], ShipmentsPerDayApi.getData);
}